import { readRemoteConfigBoolean } from '@loggi/firebase-feature-switches';
import featureSwitches from 'operations/feature-switches';
import { apiFor } from './index';

/**
 * Driver BFF when the URL is set and the kill-switch is not explicitly off.
 * SDK unreadiness must not fall back to loggi-web.
 */
export function isDriverBffEnabled() {
  if (!process.env.REACT_APP_DRIVER_BFF_URL) return false;
  return readRemoteConfigBoolean(featureSwitches.enableDriverBff) !== false;
}

export default function driverBffApi() {
  return apiFor(process.env.REACT_APP_DRIVER_BFF_URL);
}
